module.exports = new __parcel__URL__("ETHKLogo.b79115fc.png").toString();